// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"473":"a4ac9727","601":"fd281704"}[chunkId] + ".chunk.js";
};